function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudCallCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 33,
    viewBox: "0 0 27 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-headset-mic",
    d: "M18 1.5A13.5 13.5 0 0 0 4.5 15v10.5A4.494 4.494 0 0 0 9 30h4.5V18h-6v-3a10.5 10.5 0 0 1 21 0v3h-6v12h6v1.5H18v3h9a4.494 4.494 0 0 0 4.5-4.5V15A13.5 13.5 0 0 0 18 1.5z",
    transform: "translate(-4.5 -1.5)",
    style: {
      fill: "#ed3833"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCallCenter);
export default __webpack_public_path__ + "static/media/cloud_call_center.e54c7e85ba5675198debaf0d57d22732.svg";
export { ForwardRef as ReactComponent };